import axios from 'axios';
import store from '@/store';

const instance = axios.create();
instance.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response) {
            if (error.response.status === 401) {
                store.dispatch('showBlockScreen', true);
            }
        } else {
            store.dispatch('showMessage',{
                title: error.response.data.message,
                text: error.response.data.errors,
                css: "bg-danger"
            });
        }
        return error
    },
);
export default instance;

